import axios from 'axios';
import { getCSRFToken } from '../helpers';

const axiosInstance: any = axios.create({
  headers: {
    common: {
      'X-CSRF-Token': String(getCSRFToken()),
      'Accept': 'application/json',
    } as any,
  } as any,
});

export default axiosInstance;
